module.exports = __webpack_public_path__ + "img/05—Applications—Central Storage > Inline Edit.76467831.jpg";